let pincode_submit = document.querySelector(".pincode_submit");
let pincodeInput = document.querySelector(".pincode_input");
let pinMsg = document.querySelector(".pinMsg");
let pinMsgError = document.querySelector(".pinMsg-error");

pincode_submit.addEventListener("click", myFunction);
pincodeInput.addEventListener("keyup", function (event) {
  if (event.key === "Enter") {
    myFunction();
  }
});

async function myFunction() {
  // Shumee Warehouse Pincode: 560038
  checkpincode(560038);
  pinMsg.style.display = "block";
  pinMsgError.innerHTML = "";
}

async function checkpincode(ppincode) {
  // pinMsg.innerHTML = "Checking...";
  let user_given_pincode = pincodeInput.value;
  var myHeaders = new Headers();
  var raw = JSON.stringify({
    ppincode: ppincode,
    dpincode: user_given_pincode,
    weight: 2,
    cod: 1,
  });
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return fetch("https://script.google.com/macros/s/AKfycbwNM8z_tNhw-cE0viKMN-RU_6u-jAr0JYUjr4xKhSJTcu4t4AfWBUsdi7OG1AGeYF4tNw/exec?action=cd", requestOptions)
    .then((response) => response.text())
    .then((result) => {
      let etdMessage = "";
      let data = JSON.parse(result);
      if (data.status === 401) {
        pinMsg.style.display = null;
        etdMessage = "Please Enter a Valid Pincode";
        pinMsgError.innerHTML = etdMessage;
      } else {
        pinMsg.style.display = null;
        etdMessage = "Delivery by " + data.data.available_courier_companies[0].etd;
        pinMsgError.innerHTML = etdMessage;
      }
      // console.log("backend date is ",data.data.available_courier_companies[0].etd);
      return etdMessage;
    })
    .catch((error) => {
      pinMsgError.innerHTML = "Please Enter a Valid Pincode";
      // console.log("error", error);
    });
}
